export const authRoles = {
  center: ['CENTER'],
  manager: ['MANAGER'],
  // Everyone has access
};
